module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "rent-pre-registrations-menu dropdown"
  }, [(_vm.showInfoModal) ? _c('modal-bootstrap', {
    attrs: {
      "title": "Fotos e Arquivos do cadastro",
      "show": _vm.showInfoModal,
      "auto-height": true,
      "footer": "none",
      "show-close-button": false
    },
    on: {
      "close": _vm.closeInfoModal
    }
  }, [_c('div', {
    staticClass: "subtitle text-info font-18 bold"
  }, [_vm._v("\n      Libere o cadastro antes de prosseguir\n      "), _c('i', {
    staticClass: "fa fa-fw fa-info-circle"
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Para visualizar as fotos e arquivos é necessário liberar o cadastro.")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        return _vm.goPageClientsList()
      }
    }
  }, [_vm._v("Clique "), _c('a', [_vm._v("aqui")]), _vm._v(" para liberar.")])]) : _vm._e(), _vm._v(" "), _c('audio', {
    ref: "newRents",
    attrs: {
      "src": _vm.cdn('sound.mp3')
    }
  }), _vm._v(" "), _c('audio', {
    ref: "newRentSound",
    attrs: {
      "src": _vm.cdn('beep.mp3')
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-camera"
  }), (_vm.clients.length > 0) ? _c('span', {
    staticClass: "bell-badge"
  }, [_vm._v(_vm._s(_vm.clients.length))]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.clients.length > 0) ? [_c('li', {
    staticClass: "dropdown-header"
  }, [_vm._v("Arquivos recebidos")]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _vm._l((_vm.clients), function(client, i) {
    return _c('li', {
      key: i
    }, [(client.isOpenedOnSite === 0) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.openInfoModal()
        }
      }
    }, [_vm._v("\n         " + _vm._s(client.name) + "\n        ")]) : _c('router-link', {
      attrs: {
        "to": {
          name: 'clients_details',
          params: {
            clientId: client.id
          },
          query: {
            tab: 'files'
          }
        }
      }
    }, [_vm._v(_vm._s(client.name))])], 1)
  })] : _c('li', {
    staticClass: "dropdown-header"
  }, [_vm._v("Nenhum arquivo recebido no momento")])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bc87a692!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/ClientsPhotosMenu.vue
// module id = 1036
// module chunks = 34